export const REDIRECT_TRIAL_1DAY_PAGE = 'redirecionamento_pagina_trial_1_day';
